<template>
    <div>
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240)"
            :ghost="false"
            title="Report"
            sub-title="Penilaian Seluruh Nilai"
            @back="back">

            <common-training-header :withLocation="true"/>
        </a-page-header>

        <a-row style="margin-bottom: 20px;">
            <a-col class="text-right">
                <download-excel :data="excel" name="training-scores-ranking.xls">
                    <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                </download-excel>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items.user_scores" rowKey="hash" :pagination="false" bordered>

                    <a-table-column :width="50" key="number" title="No" className="align-center text-small text-left">
                        <h3 slot-scope="t,r,i" class="text-center">
                            {{ i + 1 }}
                        </h3>
                    </a-table-column>

                    <a-table-column :width="100" key="photo" title="Foto" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <div style="text-align: center">
                                <img :src="record.photo" v-if="record.photo != null" height="50" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="attendant" title="Nama" className="align-center text-small">
                        <template slot-scope="record">'
                            <h3>
                                <a-icon type="user" /> {{ record.name }} <br>
                                <a-icon type="mail" /> {{ record.email }}
                            </h3>
                        </template>
                    </a-table-column>

                    <a-table-column :width="350" key="position" title="Posisi / Asal" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <h3>{{ record.position }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column key="name" title="Penempatan" className="align-center text-small text-left" width="40%">
                        <template slot-scope="record">
                            <h3>{{ record.members[0].branch.name }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column-group>
                        <span slot="title">Nilai</span>

                        <a-table-column
                            v-for="(header) in items.headers"
                            :key="header.hash"
                            :title="toPascalCase(header.training_module) + ' ' + (header.weight * 100).toFixed(2) + '%'"
                            className="align-center text-center"
                        >
                            <template slot-scope="record">
                                <h3>{{ hashProperty(record.scores)[header.identifier] }}</h3>
                            </template>
                        </a-table-column>

                        <a-table-column
                            key="total_header"
                            title="Total 100%"
                            className="align-center text-center"
                        >
                            <template slot-scope="record">
                                <h3>{{ record.members[0].pcp_score }}</h3>
                            </template>
                        </a-table-column>
                    </a-table-column-group>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>


<script>
export default {
    data() {
        return {
            loading: false,
            items: {}
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        excel() {
            let excel = []

            if (this.loading)
                return excel

            let headers = this.items.headers

            this.items.user_scores.forEach(function(i,n) {
                let o = {
                    name: i.name,
                    position: i.position,
                }

                let b = {}

                let total = 0
                headers.forEach(function(e) {
                    b[e.identifier] = parseFloat(i.scores[e.identifier]).toFixed(2)
                    total = total +  i.scores[e.identifier]
                })

                b['total'] = parseFloat(total).toFixed(2)

                excel.push({...o, ...b})
            })

            return excel
        }
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http.get(this.routeUri('api.report.pcp.modules'))
                .then(response => {this.items = response.data})
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        hashProperty(scores){
            let score = {}

            if(!Array.isArray(scores)){
                score = scores
            }

            return score
        },
        toPascalCase(string){
            return string.replace(/(\w)(\w*)/g, function(g0,g1,g2){
                return g1.toUpperCase() + g2.toLowerCase()
            })
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    },
}
</script>
